import React from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { BaseExportType, GeneralPreferencesModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { generalPreferencesFieldsConfiguration } from './GeneralPreferences.utils';

interface GeneralPreferencesProps {
  conditions: string[];
  exports: BaseExportType[];
}

export const GeneralPreferences: React.FC<GeneralPreferencesProps> = ({ conditions, exports }) => {
  const formikProps = useFormikContext<GeneralPreferencesModel>();

  return (
    <div>
      <FormGenerator
        {...formikProps}
        fieldsConfiguration={generalPreferencesFieldsConfiguration(conditions, exports)}
        formDisabled={false}
        newEditableLook
        dataTestId="preferences-general-form"
      />
    </div>
  );
};
